// Pure rules for the Dream Prize block, read from the same summary the embed
// uses (GET /api/embed/v1/rewards/dream/summary/). The formatters keep the
// embed's names and output (formatNumber.js, rewardPeriodCountdown.js).

/** "2,700": comma-grouped, the way the pills and the designs show counts. */
export function formatDisplayNumber(n) {
  const x = Number(n) || 0;
  return x.toLocaleString('en-US');
}

function compactParts(delta) {
  const days = Math.floor(delta / 86400000);
  const hours = Math.floor((delta % 86400000) / 3600000);
  const minutes = Math.floor((delta % 3600000) / 60000);
  const seconds = Math.floor((delta % 60000) / 1000);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
}

/** Two-unit duration, "6d 12h", the way the embed's boost banner counts. */
export function formatCompactDuration(delta) {
  return compactParts(delta);
}

/** Two-unit countdown, "6d 12h left". */
export function formatCompactCountdown(endTimestampMs, nowMs, endedText) {
  if (!endTimestampMs || !Number.isFinite(endTimestampMs)) return '';
  const now = nowMs != null ? nowMs : Date.now();
  const delta = endTimestampMs - now;
  if (delta <= 0) return endedText || 'Ended';
  return `${compactParts(delta)} left`;
}

function instantMs(iso) {
  const ms = iso ? new Date(iso).getTime() : NaN;
  return Number.isFinite(ms) ? ms : null;
}

/**
 * The period block's countdown: to `ends_at` while the period runs, to
 * `starts_at` before it opens. Decided by the moments, not by `status`.
 */
export function periodCountdownLabel(period, nowMs) {
  if (!period) return '';
  const now = nowMs != null ? nowMs : Date.now();
  const startMs = instantMs(period.starts_at);
  if (startMs != null && startMs > now) return `Starts in ${compactParts(startMs - now)}`;
  return formatCompactCountdown(instantMs(period.ends_at), now, 'Ended');
}

/** The moment the period block counts down to: its start before it opens, then its end. */
export function countdownTargetMs(period, nowMs) {
  if (!period) return null;
  const now = nowMs != null ? nowMs : Date.now();
  const startMs = instantMs(period.starts_at);
  if (startMs != null && startMs > now) return startMs;
  return instantMs(period.ends_at);
}

/** Dream UI shows only with the school's program on and a current period. */
export function shouldShowDream(summary) {
  return !!(summary && summary.enabled === true && summary.period);
}

/** The active prize draw Home shows: `featured_draw` from the summary. */
export function featuredDraws(summary) {
  if (!shouldShowDream(summary) || !summary.featured_draw) return [];
  return [summary.featured_draw];
}

/** Open bonus drops, shown two to a row. */
export function openBonusDrops(summary) {
  if (!shouldShowDream(summary)) return [];
  return Array.isArray(summary.bonus_drops) ? summary.bonus_drops.filter(Boolean) : [];
}
